
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SendCampaignDetailsGrid extends Serenity.EntityGrid<SendCampaignDetailsRow, any> {
        protected getColumnsKey() { return 'Administration.SendCampaignDetails'; }
        protected getDialogType() { return SendCampaignDetailsDialog; }
        protected getIdProperty() { return SendCampaignDetailsRow.idProperty; }
        protected getInsertPermission() { return SendCampaignDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return SendCampaignDetailsRow.localTextPrefix; }
        protected getService() { return SendCampaignDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}